import { useParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import TextArea from 'modules/core/components/TextArea'
import { useForm } from 'modules/core/hooks/useForm'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useSendProcessTaskReminder } from 'modules/processes/hooks/process/useSendProcessTaskReminder'

import { useProcessOverviewTasks } from './ProcessOverviewTasksProvider'

type Props = {
  onSuccess: () => void
  onClose: () => void
}

export const SendTaskReminderModal = ({ onSuccess, onClose }: Props) => {
  const { loading, sendTaskReminders } = useSendProcessTaskReminder()
  const { taskIds } = useProcessOverviewTasks()
  const { category } = useParams()

  const { values, setValues, submitForm } = useForm({
    defaultValues: {
      message: '',
      taskIds,
    },
    onSubmit: async (data, { setErrors }) => {
      track(trackingEvents.processes.sendTaskReminderFromOverview, {
        category: category || 'unknown',
      })
      const result = await sendTaskReminders({
        ids: data.taskIds,
        message: data.message,
      })

      const handled = handleResult(result, () => {
        setErrors({
          message: i18n.t('processes.process.overview.tasks_table.reminder.empty'),
        })
      })

      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('processes.process.overview.tasks_table.reminder.success'),
        })
        onSuccess()
      }

      return handled
    },
  })

  return (
    <Modal
      title={i18n.t('processes.process.overview.tasks_table.reminder.title')}
      description={i18n.t('processes.process.overview.tasks_table.reminder.description')}
      illustration="send-email-envelope"
      onSubmit={submitForm}
      onClose={onClose}
      locked={false}
      footer={
        <>
          <Button disabled={false} type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button loading={loading} disabled={false} submit>
            {i18n.t('processes.process.overview.tasks_table.reminder.submit')}
          </Button>
        </>
      }
    >
      <TextArea
        value={values.message}
        onChange={(e) => setValues({ ...values, message: e })}
        placeholder={i18n.t('processes.process.overview.tasks_table.reminder.placeholder')}
      />
    </Modal>
  )
}
